import { Directive } from '@angular/core';

//REV-21369 — die zwei Steckplätze der Einzelansicht (ADR-0021 E6).
//
//`abcp-document-detail` bleibt eine Pure View: sie zeichnet weder den PDF-Viewer noch die Kommentare
//selbst, sie macht nur PLATZ dafür. Der Wirt (die Seite) projiziert hinein, was Bytes und Notizen
//braucht — Netz und Store gehören ihm, nicht der Ansicht.

/**
 * Markiert den projizierten Beleg-Viewer. Ist er da, tritt er an die Stelle der Vorschau
 * (`abcp-document-preview`), die für Nicht-PDFs und ohne Viewer bleibt, was sie war.
 */
@Directive({ selector: '[abcpDocumentViewer]' })
export class AbcpDocumentViewerSlotDirective {}

/** Markiert die projizierte Kommentar-Spalte — sie steht am Ende der Seitenleiste. */
@Directive({ selector: '[abcpDocumentNotes]' })
export class AbcpDocumentNotesSlotDirective {}
